import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="bg-[#050505] pt-20 pb-10 border-t border-white/10 relative overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        {/* Mega wordmark */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="pb-24 md:pb-32 border-b border-white/10"
        >
          <h2 className="font-serif font-light tracking-[-0.04em] uppercase text-white leading-none text-[24vw] md:text-[18vw] whitespace-nowrap">
            <span className="relative inline-block align-baseline">
              Seven
              <span
                aria-label="Car Detailing"
                className="absolute left-0 right-6 md:right-24 lg:right-32 top-full mt-2 md:mt-4 flex justify-between font-mono uppercase text-neutral-500 text-sm md:text-2xl lg:text-3xl leading-none"
              >
                {"CAR DETAILING".split("").map((c, i) => (
                  <span key={i} aria-hidden="true">
                    {c === " " ? "\u00A0" : c}
                  </span>
                ))}
              </span>
            </span>
            <span className="italic text-brand-red">7</span>h
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 py-12 text-sm">
          <div className="md:col-span-4">
            <p className="eyebrow mb-3">Studio</p>
            <p className="text-neutral-300">39 Reynolds Drive</p>
            <p className="text-neutral-300">Paralowie SA 5108</p>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow mb-3">Contact</p>
            <a
              href="tel:0429052189"
              className="block text-neutral-300 hover:text-white"
            >
              0429 052 189
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow mb-3">Hours</p>
            <p className="text-neutral-300">7 Days · 08:30 — 18:30</p>
          </div>
          <div className="md:col-span-2 text-left md:text-right">
            <p className="eyebrow mb-3">Sitemap</p>
            <div className="flex md:flex-col gap-4 md:gap-1 text-neutral-300">
              <a href="/#services" className="hover:text-white">Services</a>
              <a href="/shop" className="hover:text-white">Shop</a>
              <a href="/#process" className="hover:text-white">Process</a>
              <a href="/#booking" className="hover:text-white">Book</a>
              <a href="/#contact" className="hover:text-white">Contact</a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-500">
          <span>© {new Date().getFullYear()} SEVEN7H Car Detailing · All Rights Reserved</span>
          <span>Where Perfection Meets the Road</span>
        </div>
      </div>
    </footer>
  );
}
